import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import InputDate from 'components/InputDate/view/mobile';
import Button from 'components/Button';
import CheckBox from 'components/CheckBox';

import DaysFilter from 'features/reports/view/desktop/DaysFilter';

import './FilterBlock.scss';

const b = block('player-deposits-filter-desktop');

const FilterBlock = ({ model }) => {
  const locale = useSelector(s => s.locale.locale);

  const { state, handlers } = model;

  const checkboxes = ['all', 'deposit', 'withdrawal'].map(v => {
    const isChecked = state.values.type.includes(v);

    return <label className={b('checkbox-wrapper')} key={v}>
      <div className={b('checkbox')}>
        <CheckBox checked={isChecked} onChange={() => handlers.handleTypeChange(v)} />
      </div>
      {locale[v]}
    </label>
  });

  return (
    <div className={b()}>
      <h2 className={b('title')}>{locale.filter}</h2>

      <form className={b('form')} onSubmit={handlers.handlePlayerDepositsSubmit}>
        <div className={b('part')}>
          <DaysFilter activeDay={state.activeDay} setActiveDay={handlers.handleChangeActiveDay} count={6} withZero />

          <div className={b('or')}>{locale.or}</div>

          <div className={b('item')}>
            <div className={b('item-label')}>{locale.dateFrom}</div>
            <div className={b('item-field')}>
              <InputDate
                selected={state.values.from}
                onChange={v => handlers.handleValueChange('from', v)}
              />
            </div>
          </div>

          <div className={b('item')}>
            <div className={b('item-label')}>{locale.dateUntil}</div>
            <div className={b('item-field')}>
              <InputDate
                selected={state.values.to}
                onChange={v => handlers.handleValueChange('to', v)}
              />
            </div>
          </div>
        </div>

        <div className={b('part')}>
          <div className={b('item')}>
            <div className={b('item-label')}>ID</div>
            <div className={b('item-field')}>
              <Input
                size="low"
                value={state.values.id}
                onChange={e => handlers.handleValueChange('id', e.target.value)}
                placeholder='ID'
              />
            </div>
          </div>

          <div className={b('item')}>
            <div className={b('item-label')}>{locale.username}</div>
            <div className={b('item-field')}>
              <Input
                size="low"
                value={state.values.username}
                onChange={e => handlers.handleValueChange('username', e.target.value)}
                placeholder={locale.username}
              />
            </div>
          </div>

          <div className={b('checkboxes')}>
            {checkboxes}
          </div>

          <div className={b('button')}>
            <Button text={locale.acceptFilter} type="submit" />
          </div>
        </div>
      </form>
    </div>
  );
};

export default FilterBlock;
